import React from 'react';
import createIcon from './createIcon';

const Star = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <title>Star</title>
    <polygon points="480,200 308.519,200 256.029,32 203.519,200 32,200 170.946,304.209 116,480 256,368 396,480 341.073,304.195" />
  </svg>
);

Star.displayName = 'Star';

export default createIcon(Star);
